import React, { useState, useEffect, useCallback } from 'react'
// import ReCAPTCHA from 'react-google-recaptcha';
import './workshopdetails.css'
import { NavLink } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import workshop03 from '../../../images/workshop_images/workshop03.png'
import duration from '../../../images/workshop_images/duration.png'
import language from '../../../images/workshop_images/language.png'
import timings from '../../../images/workshop_images/timing.png'
import start_date from '../../../images/workshop_images/start-date.png'
import fees from '../../../images/workshop_images/money.png'
import location from '../../../images/workshop_images/loction.png'
import learn05 from '../../../images/workshop_images/learn05.png';
import learn06 from '../../../images/workshop_images/learn06.png';
import learn07 from '../../../images/workshop_images/learn07.png';
import learn04 from '../../../images/workshop_images/learn04.png'
import accept from '../../../images/workshop_images/accept.png'
import health_seekers from '../../../images/workshop_images/health_seekers.png'
import eco from '../../../images/workshop_images/eco.png';
import begineers from '../../../images/workshop_images/begineers.png';
import city from '../../../images/workshop_images/city.png';
import busy from '../../../images/workshop_images/busy.png';
import family from '../../../images/workshop_images/family.png';
import student from '../../../images/workshop_images/student.png'
import cross from '../../../images/workshop_images/cross.png'
import kids from '../../../images/workshop_images/kids.png';
import practical from '../../../images/workshop_images/practical.png';
import holistic from '../../../images/workshop_images/holistic.png'
import expert from '../../../images/workshop_images/expert.png'



function CountdownTimer({ targetDate }) {
    const calculateTimeLeft = useCallback(() => {
        const difference = new Date(targetDate) - new Date();
        if (difference > 0) {
            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((difference / 1000 / 60) % 60);
            const seconds = Math.floor((difference / 1000) % 60);
            return { days, hours, minutes, seconds };
        }
        return null;
    }, [targetDate]);

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [calculateTimeLeft]);

    if (!timeLeft) {
        return <p className="text-danger">The workshop has started!</p>;
    }

    return (
        <div className="countdown-timer">
            <div className="time-box">
                <span>{timeLeft.days}</span>
                <small>Days</small>
            </div>
            <div className="time-box">
                <span>{timeLeft.hours}</span>
                <small>Hours</small>
            </div>
            <div className="time-box">
                <span>{timeLeft.minutes}</span>
                <small>Minutes</small>
            </div>
            <div className="time-box">
                <span>{timeLeft.seconds}</span>
                <small>Seconds</small>
            </div>
        </div>
    );
}



function Workshopdetails03() {

    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const accordionData = [
        {
            title: "What happens after I register? ",
            content:
                "After you submit your details through the Contact Us form, our team will provide you with payment instructions. Complete the payment and share the screenshot with us. Your seat will be confirmed once the payment is verified.",
        },
        {
            title: " How can I stay connected after the workshop? ",
            content: (
                <>
                    You can join Anuyog’s WhatsApp Group to continue your journey toward natural living with like-minded individuals.{" "}
                    <a href="https://chat.whatsapp.com/JEe0oM19XXd4LHjicaIzgf" target="_blank" rel="noopener noreferrer">
                        Join Here
                    </a>
                </>
            ),
        },
        {
            title: "Does the workshop offer a recorded session or a live session?",
            content:
                "The workshop is conducted live by our expert facilitators, providing real-time interaction ",
        },
        {
            title: " How can I prepare for the workshop?",
            content: [
                "Ensure a stable internet connection for the online sessions.",
                "Keep a notebook and pen handy for taking notes.",
                "Be ready to participate actively and implement the learnings.",
            ],
            type: "list",
        },
        {
            title: "Can I get a refund if I cannot attend?",
            content:
                "Refunds are not available, but you can transfer your spot to someone else if you notify us in advance.",
        },
        {
            title: " Can I access recordings if I miss a session?",
            content:
                "Currently, live participation is encouraged for the best experience. Recordings may be offered in future workshops.",
        },
        {
            title: "Will there be an interactive component?",
            content:
                "Yes! Each day includes an interactive Q&A session where you can ask questions and clarify your doubts.",
        },
        {
            title: "Will I receive a confirmation email after registering?",
            content:
                "Yes, once you complete the registration process, you will receive a confirmation email with all the necessary details about the workshop, including the schedule and joining instructions. Make sure to check your inbox (and spam folder) for this email.",
        },
        {
            title: "How can I stay connected after the workshop?",
            content:
                "You can join Anuyog’s Whatapp Group (https://chat.whatsapp.com/JEe0oM19XXd4LHjicaIzgf) to continue your journey toward natural living with like-minded individuals. ",
        },
    ];


    // const [formData, setFormData] = useState({
    //     name: '',
    //     email: '',
    //     phone: '',
    // });

    // const [isSubmitting, setIsSubmitting] = useState(false);
    // const [message, setMessage] = useState('');
    // const [recaptchaToken, setRecaptchaToken] = useState(null);
    // const [recaptchaError, setRecaptchaError] = useState(false);
    const workshopDate = '2025-06-22T19:00:00'




    useEffect(() => {
        AOS.init({ duration: 1500, easing: 'ease-in-out' });
    }, []);

    // const handleChange = (e) => {
    //     const { id, value } = e.target;
    //     setFormData((prev) => ({ ...prev, [id]: value }));
    // };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setIsSubmitting(true);
    //     setMessage('');

    //     if (!recaptchaToken) {
    //         setMessage('Please complete the reCAPTCHA');
    //         setIsSubmitting(false);
    //         return;
    //     }

    //     try {
    //         const response = await fetch('https://efsouls.pythonanywhere.com/smtp_api/', {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(formData),
    //         });

    //         if (response.ok) {
    //             setMessage('Thank you for registering! We will contact you soon.');
    //             setFormData({ name: '', email: '', phone: '' });
    //         } else {
    //             setMessage('Something went wrong. Please try again later.');
    //         }
    //     } catch (error) {
    //         setMessage('An error occurred. Please try again.');
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };

    // const handleRecaptchaChange = (token) => {
    //     if (token) {
    //         setRecaptchaToken(token);
    //         setRecaptchaError(false);
    //     } else {
    //         setRecaptchaError(true);
    //     }
    // };
    return (
        <>
            <section className="book-section register_detail">
                <div className="container">
                    <div className='book register_book'>
                        <div className="book-text" data-aos="fade-right" data-aos-duration="2000">
                            <h1 className='text-start'>Gardening Simplified
                            </h1>
                            <h4 className='fw-bold text-start mb-4'><strong>Unlock the Secrets to Grow Your Own Healthy Harvest
                            </strong></h4>
                            <div className="countdown mt-4">
                                <h5 className="mb-3 fw-bold text-start">Workshop Will Start In:</h5>
                                <CountdownTimer targetDate={workshopDate} />
                            </div>
                            <div className="how mt-4">
                                <NavLink
                                    to='/contact'
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                      }}
                                >
                                    <button type="button" className="btn">Register Now</button>
                                </NavLink>
                            </div>
                            <p className='mt-4
                            
                            '><strong style={{ color: '#9D3B24' }}>Learn to take charge of your health with your own natural produce.</strong></p>
                        </div>
                        <div className="success-vidio image-wrapper">
                            <img src={workshop03} alt="" srcset="" />
                        </div>
                    </div>
                </div>
            </section>


            <section className='is_this_you-section'>
                <div className="container">
                    <h1 className='text-center offering-title mb-5'>Is This You?</h1>
                    <div className="is_this_you">
                        <ul>
                            <li><strong>Looking for healthier, chemical-free food options?
                            </strong></li>
                            <li><strong>Experiencing delayed healing due to food chemicals?</strong></li>
                            <li><strong>Want to take control of your food’s quality?
                            </strong></li>
                            <li><strong>Interested in growing your own healing, organic garden?
                            </strong></li>
                        </ul>
                        <h3 className='fw-bold text-success'>If you answered 'YES' to any of the above, this workshop is for you!</h3>
                    </div>
                </div>
            </section>





            <section className='info-section' id='workshop_details'>
                <div className="details">
                    <h2 className='text-center fw-bold mb-4'>Details Of The Workshop</h2>
                    <div className="all-details workshop-details">


                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5 className='text-start'><img src={start_date} alt="" /><strong> Date:</strong> 22 June 2025</h5>
                        </div>

                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5 className='text-start'><img src={language} alt="" /><strong>Language:</strong> Hindi and English</h5>
                        </div>
                        <div className="block" data-aos="fade-left" data-aos-duration="2000">
                            <h5 className='text-start'><img src={timings} alt="" /><strong> Timings:</strong> 7:00 PM - 8:30 PM IST</h5>

                        </div>
                        <div className="block" data-aos="fade-left" data-aos-duration="2000">

                            <h5 className='text-start'><img src={duration} alt="" /><strong>Duration:</strong> 90 minutes </h5>
                        </div>
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">

                            <h5 className='text-start'><img src={fees} alt="" /><strong>Course Fee:</strong> <s>Rs. 349</s> Rs. 199 </h5>
                        </div>
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">

                            <h5 className='text-start'><img src={location} alt="" /><strong> Location:</strong> Online </h5>
                        </div>
                    </div>
                </div>
            </section>




            <section className='why-join-section pillar-section'>
                <div className="container">
                    <div className="pillar">
                        <h2 className='mb-4' data-aos="fade-down" data-aos-duration="3000"><strong style={{ color: '#9D3B24' }}>Why Join This Workshop?</strong></h2>
                        <h4 className='fw-bold mb-5 offering-title' data-aos="fade-down" data-aos-duration="3000">This isn’t your This isn’t just a gardening class—it’s your gateway to a healthier, sustainable lifestyle!
                        </h4>
                    </div>
                    <div className="all-pillar">
                        <div className="pillar-detail">
                            <div className="pillar-image">
                                <div>
                                    <img src={expert} alt="" />
                                </div>
                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Expert Driven</h5>
                                <h6 className='fw-bold'>Live session by an Organic Farmpreneur with many years of experience in sustainable farming.</h6>
                            </div>
                        </div>
                        <div className="pillar-detail">
                            <div className="pillar-image">

                                <img src={holistic} alt="" />

                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Holistic Approach  </h5>
                                <h6 className='fw-bold'>Learn how gardening connects health, sustainability, and mindful living.
                                </h6>
                            </div>
                        </div>
                        <div className="pillar-detail">
                            <div className="pillar-image">

                                <img src={kids} alt="" />
                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Kids' Involvement </h5>
                                <h6 className='fw-bold'>Fun way for kids to learn how food grows while building responsibility and a love for nature.
                                </h6>
                            </div>
                        </div>

                        <div className="pillar-detail">
                            <div className="pillar-image">
                                <div>
                                    <img src={practical} alt="" />
                                </div>
                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Practical and Personalized </h5>
                                <h6 className='fw-bold'>Get tailored tips and advice to suit your space and lifestyle through Anuyog Consultancy.
                                </h6>
                            </div>
                        </div>
                        

                       
                    </div>
                </div>

            </section>







            <section className='what_learn-section' id='workshop_details'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="include">
                                <h1 className='text-center'>What You’ll Learn?</h1>
                                <h5 className='fw-bold text-center'>We’ve designed this workshop to be simple, fun, and packed with practical insights:
                                </h5>
                                <div className="include-details">
                                    <div className="include-images">
                                        <img src={learn05} alt="" />
                                    </div>
                                    <div className="include-text">
                                        <h2 className='fw-bold text-start'>Why is Eating Right So Important?
                                        </h2>
                                        <ul className='text-start'>
                                            <li>Discover how food acts as medicine and the impact of modern farming practices on your health and healing journey.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="include-details">
                                    <div className="include-images">
                                        <img src={learn06} alt="" />
                                    </div>
                                    <div className="include-text">
                                        <h2 className='fw-bold text-start'>How Can You Grow Your Own Vegetables?
                                        </h2>
                                        <ul className='text-start'>
                                            <li>Learn practical methods to grow fresh produce, even in small spaces like balconies, rooftops, or backyards.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="include-details">
                                    <div className="include-images">
                                        <img src={learn07} alt="" />
                                    </div>
                                    <div className="include-text">
                                        <h2 className='fw-bold text-start'> Essential Gardening Techniques for Beginners
                                        </h2>
                                        <ul className='text-start'>
                                            <li>Master the basics of soil preparation, planting, watering, and easy maintenance to kickstart your gardening journey.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="include-details">
                                    <div className="include-images">
                                        <img src={learn04} alt="" />
                                    </div>
                                    <div className="include-text">
                                        <h2 className='fw-bold text-start'> Sustainable Practices in Kitchen Gardening
                                        </h2>
                                        <ul className='text-start'>
                                            <li>Explore eco-friendly gardening methods, turning kitchen scraps and household waste into natural solutions for organic growth.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <NavLink
                                to="/contact"
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="right-block">
                                    <h4 className='fw-bold'>Gardening Simplified</h4>
                                    <h6 className='text-dark fw-bold mb-4'>Unlock the Secrets to Grow Your Own Healthy Harvest
                                    </h6>
                                    <ul className='text-start'>
                                        <li className='fw-bold text-dark'>
                                            <img src={start_date} alt="" />
                                            22 June 2025
                                        </li>
                                        <li className='fw-bold text-dark'>
                                            <img src={fees} alt="" />
                                            Fees: <s>Rs. 349</s> Rs.199
                                        </li>
                                        <li className='fw-bold text-dark'>
                                            <img src={timings} alt="" />
                                            7:00 PM to 8:30 PM IST
                                        </li>
                                    </ul>
                                    <h5 className='fw-bold'>Learn to take charge of your health with your own natural produce.</h5>
                                    <h6 className='fw-bold text-dark'>Begin your journey to a healthy, meaningful life in just 90 minutes—don’t miss out!
                                    </h6>
                                    <div className="how mt-4">

                                        <button type="button" className="btn">Register Now</button>

                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </section>

            <section className='host-section' id='workshop_details'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <h1 className='mb-2 mt-5'>About Our Host</h1>
                            <div className="host">

                                <div className="host-image">
                                    <img src="/images/drjain.jpeg" alt="" />
                                </div>
                                <div className="host-text">
                                    <h2 className='fw-bold'>Rohit Jain</h2>
                                    <p>Rohit Jain, co-founder of Banyan Roots, has over 14 years of experience in organic food and farming, with a focus on reviving traditional, sustainable agricultural practices and food habits. His work began with tribal farmers in Rajasthan, where he encouraged the use of indigenous seeds and ecological farming methods to protect soil health and biodiversity. Rohit advocates for a return to natural farming processes that avoid harmful chemicals, ultimately leading to healthier food.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='yes-section' id='workshop_details'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="yes">
                                <div className="yes-header">
                                    <h1>Who is this for?</h1> <img src={accept} alt="" />
                                </div>
                                <h5 className='fw-bold text-start'>The course is designed for everyone seeking a balanced and healthier lifestyle.</h5>
                                <div className="all-information">
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={health_seekers} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Health Enthusiasts</h4>
                                            <h5 className='fw-bold'> looking to grow organic food for better well-being.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={eco} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Eco-conscious Individuals</h4>
                                            <h5 className='fw-bold'>wanting to embrace sustainable living.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={begineers} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Beginners</h4>
                                            <h5 className='fw-bold'>eager to start gardening with easy, practical methods.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={city} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>City Gardeners</h4>
                                            <h5 className='fw-bold'> with limited space for home gardening.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={busy} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Busy Professionals</h4>
                                            <h5 className='fw-bold'> seeking quick ways to grow fresh produce.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={family} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Families </h4>
                                            <h5 className='fw-bold'>wanting to involve kids in fun gardening activities.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={student} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Students</h4>
                                            <h5 className='fw-bold'> interested in learning gardening, even in small spaces.
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="yes-header mt-5">
                                    <h1>Who is it not for?</h1> <img src={cross} alt="" />
                                </div>
                                <h5 className='fw-bold text-start'>This program isn't suitable for those not serious about their health.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='register_faq-section' id='workshop_details'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="register-faq">
                                <h1>FAQs</h1>
                                <div className="faq-image">
                                    <img src={workshop03} alt="" />
                                </div>
                                <div className="accordion justify-content-center">
                                    {accordionData.map((item, index) => (
                                        <div className="accordion-item" key={index}>
                                            <button
                                                className="accordion-button"
                                                aria-expanded={activeIndex === index ? 'true' : 'false'}
                                                onClick={() => toggleAccordion(index)}
                                            >
                                                <span className="accordion-title">{item.title}</span>
                                                <span className="icon" aria-hidden="true"></span>
                                            </button>
                                            {activeIndex === index && (
                                                <div className="accordion-content">
                                                    {item.type === "list" ? (
                                                        <ul>
                                                            {item.content.map((listItem, i) => (
                                                                <li key={i}>{listItem}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p>{item.content}</p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="register-section" id="register-form">
                <div className="form-container">
                    <div className="form-wrapper">
                        <h2 className="form-title">Join Us Today</h2>
                        <p className="form-description">Fill out the form below to get started!</p>
                        <form className="register-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    placeholder="Enter your name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <input
                                type="hidden"
                                name="subject"
                                value="Registration form Submission"
                            />
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="Enter your email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="phone">Phone Number</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    placeholder="Enter your phone number"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-12 recaptcha-container register-recaptcha">
                                <ReCAPTCHA
                                    sitekey="6Lda7XYqAAAAAA9wI26_P6V4r9o8pws3uRnM-_GL"
                                    onChange={handleRecaptchaChange}
                                />
                                {recaptchaError && (
                                    <p style={{ color: 'red' }}>reCAPTCHA failed to load. Please try again.</p>
                                )}
                            </div>
                            <button type="submit" className="submit-button" disabled={isSubmitting}>
                                {isSubmitting ? 'Submitting...' : 'Submit'}
                            </button>
                        </form>
                        {message && <p className="form-message">{message}</p>}
                    </div>
                </div>
            </section> */}
        </>
    )
}

export default Workshopdetails03
